export default __webpack_public_path__ + "static/media/miguel-lopes-33.643cda8b.jpg";